var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0647 6.88949V10.616H14.8711L14.0777 15.743H10.0647V28H4.56763V15.743H0V10.616H4.56763V5.4533C4.56763 2.4433 7.01093 0 10.0209 0H15.1812V4.63968H12.312C11.071 4.63968 10.0638 5.64841 10.0638 6.88949H10.0647Z","fill":"white"}));
}

SocialFacebook.defaultProps = {"width":"16","height":"28","viewBox":"0 0 16 28","fill":"none"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
